import { debounce } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";

export interface Example {
  slug: string;
  name: string;
  emoji: string;
  color?: string;
  repository_url: string;
  pipeline_url?: string;
  clone_url: string;
  ssh_url: string;
  default_branch: string;
  updated_at: string;
  description?: string;
  documentation?: string;
  languages?: string[];
  yaml_config?: string;
}

export function useExamples(examplesPath: string) {
  const [examples, setExamples] = useState<Example[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [query, setQuery] = useState("");

  const loadExamples = useCallback(
    async (query?: string) => {
      setLoading(true);
      setError(false);

      const url = new URL(examplesPath, window.location.origin);

      if (query) {
        url.searchParams.set("query", query);
      }

      try {
        const response = await fetch(url);
        const examples = await response.json();

        setExamples(examples);
      } catch (error) {
        setError(true);
      } finally {
        setLoading(false);
      }
    },
    [examplesPath],
  );

  const debouncedLoadExamples = useMemo(() => debounce(loadExamples, 500), [loadExamples]);

  // Load initial examples
  useEffect(() => {
    loadExamples();
  }, [loadExamples]);

  return {
    examples,
    loading,
    error,
    query,
    setQuery: (value: string) => {
      setQuery(value);
      debouncedLoadExamples(value);
    },
  };
}
